import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Agencies)',
  collection: {
    endpoint: '/api/admin/truevail/admin/agencies',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Agency)', key: 'team.title', sort: 'title', primary: true, format: (agency) => (
        <TeamToken { ...agency.team } />
      ) },
      { label: 't(Advisors)', key: 'advisors_count', collapsing: true, align: 'right', visible: false },
      { label: 't(Status)', key: 'team.status', sort: 'status', collapsing: true, format: StatusToken }
    ],
    defaultSort: { key: 'title', order: 'asc' },
    empty: {
      icon: 'building',
      title: 't(No Agencies)',
      text: 't(You have not yet created any agencies)'
    },
    entity: 'agency',
    onClick: (record) => context.router.push(`/admin/truevail/admin/agencies/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
